import {
  NOTIFICATIONS_SETTINGS_PAGE_DESCRIPTION,
  ACCOUNT_SETTINGS_PAGE_DESCRIPTION,
  BILLING_SETTINGS_PAGE_DESCRIPTION,
  CUSTOMIZATION_SETTINGS_PAGE_DESCRIPTION,
  DOMAINS_SETTINGS_PAGE_DESCRIPTION,
  GENERAL_SETTINGS_PAGE_DESCRIPTION,
  MESSAGING_SETTINGS_PAGE_DESCRIPTION,
  PAYMENTS_SETTINGS_PAGE_DESCRIPTION,
  PUBLIC_WEBSITE_SETTINGS_PAGE_DESCRIPTION,
  TEAMS_SETTINGS_PAGE_DESCRIPTION,
  APP_SETTINGS_PAGE_DESCRIPTION,
  FILE_SETTINGS_PAGE_DESCRIPTION,
  API_SETTINGS_PAGE_DESCRIPTION,
  MODULE_MANAGEMENT_DESCRIPTION,
} from './stringConsts';
import { NotificationIcon } from '../components/Icons/NotificationIcon';
import { HomeIcon } from '../components/Icons/ModuleIcons/HomeIcon';
import { DEFAULT_REFERRAL_AMOUNT } from './referralConsts';
import { AUTH_STATES } from './authConsts';
import {
  PagesIcon,
  PagesDarkIcon,
  AccountIcon,
  ClientsIcon,
  BillingIcon,
  FilesIcon,
  MessagesIcon,
  PaymentsIcon,
  TeamIcon,
  HardwareChipIcon,
  FormsIcon,
  BookOpenIcon,
  LinkIcon,
  PuzzleIcon,
  QuestionIcon,
  AppsIcon,
  GiftIcon,
  PortalModulesIcon,
  ExternalLinkIcon,
  PartnerAppsIcon,
  CustomizationIcon,
} from '../components/Icons';
import { PublicSitePages } from './landingConsts';
import { PlanIcon } from '../components/Icons/Plan';
import { StatusIcon } from '../components/Icons/StatusIcon';

export const PRODUCTS_PAGE = '/products';

export const COMPANIES_PAGE = {
  path: '/clients/companies',
  label: 'Client Companies',
  icon: ClientsIcon,
};

export const USERS_PAGE = {
  path: '/clients/users',
  label: 'Clients',
  icon: ClientsIcon,
};

export const INBOX_PAGE = {
  path: '/notifications',
  label: 'File Notifications',
  icon: NotificationIcon,
};

export const CRM_PAGE = {
  path: '/clients/users',
  label: 'CRM',
  icon: ClientsIcon,
};

export const CLIENTS_IMPORT_PAGE = {
  path: '/clients/import',
};

export const HOME_PAGE = {
  path: '/',
  label: 'Home',
  icon: HomeIcon,
};

export const EXTENSION_EMBED_PAGE = {
  path: '/extensions',
  label: '',
};

export const CLIENT_DETAILS_PAGE = {
  path: '/clients/users/details',
  label: 'Client Users',
  icon: ClientsIcon,
};

export const EXPERIENCE_SETUP_PAGE = '/create-ad';

export const MARKETING_PAGE_URL = 'https://www.lightout.com';

export const EXPERIENCES_PAGE = '/feed';

export const PACKAGES_PAGE = '/packages';

export const LOGIN_PAGE = `/login?step=${AUTH_STATES.SIGN_IN}`;

export const REGISTER_PAGE = `/login?step=${AUTH_STATES.SIGN_UP}`;

export const REQUIRE_NEW_PASSWORD = `/login?step=${AUTH_STATES.REQUIRE_NEW_PASSWORD}`;

export const CONFIRM_REGISTER_PAGE = `/login?step=${AUTH_STATES.CONFIRM_SIGN_UP}`;

export const FORGOT_PASSWORD_PAGE = `/login?step=${AUTH_STATES.FORGOT_PASSWORD}`;

export const LANDING_PAGE_ROUTE = `/landing-page`;

export const LANDING_EDIT_PAGE = `${LANDING_PAGE_ROUTE}/edit?page`;

export const SETTINGS_PAGE = '/settings';

export const ARTICLE_PAGE = '/article';

export const INVOICE_PATH = '/inv';

export const ARTICLE_PATH = '/art';

export const SHORT_LINK_PATH = '/sl';

export const KNOWLEDGE_BASE_PAGE = {
  path: '/helpdesk',
  label: 'Helpdesk',
  icon: BookOpenIcon,
};

export const FILES_PAGE = {
  path: '/files',
  label: 'Files',
  icon: FilesIcon,
};
export const ARTICLES_PAGE = {
  path: '/articles',
  label: 'Knowledge base',
  icon: BookOpenIcon,
};

export const INVOICES_PAGE = {
  path: '/invoices',
  label: 'Invoices',
  icon: PaymentsIcon,
  description: PAYMENTS_SETTINGS_PAGE_DESCRIPTION,
};

export const SUBSCRIPTION_PAGE = {
  path: '/subscriptions',
  label: 'Subscriptions',
  icon: PaymentsIcon,
  description: PAYMENTS_SETTINGS_PAGE_DESCRIPTION,
};
export const MESSAGES_PAGE = {
  path: '/messaging',
  label: 'Messages',
  icon: MessagesIcon,
  description: MESSAGING_SETTINGS_PAGE_DESCRIPTION,
};

export const HELP_CENTER_PAGE = {
  path: '/help-center',
  label: 'Help Center',
  icon: QuestionIcon,
};

export const LANDING_PAGE = {
  path: LANDING_PAGE_ROUTE,
  label: 'Pages',
  icon: PagesIcon,
  pageIcon: PagesDarkIcon,
};
export const SETTINGS_PAGE_ROOT_PATH = '/settings';

export const CUSTOMIZATION_PAGE = {
  path: '/customization',
  label: 'Customization',
  description: CUSTOMIZATION_SETTINGS_PAGE_DESCRIPTION,
  icon: ExternalLinkIcon,
};

export const MODULE_MANAGEMENT_PAGE = {
  path: '/module-management',
  label: 'App setup',
  description: MODULE_MANAGEMENT_DESCRIPTION,
  icon: CustomizationIcon,
};

export const BILLING_PAGE = {
  path: '/settings/billing',
  label: 'Payment methods',
  icon: BillingIcon,
  description: PAYMENTS_SETTINGS_PAGE_DESCRIPTION,
};

export const SETUP_MODULE_PAGE_BASE_PATH = `${MODULE_MANAGEMENT_PAGE.path}/setup`;

export const FILES_SETTINGS_PAGE = {
  path: '/settings/files',
  label: 'Files',
  icon: FilesIcon,
  description: FILE_SETTINGS_PAGE_DESCRIPTION,
};

export const NOTIFICATIONS_SETTINGS_PAGE = {
  path: '/settings/notifications',
  label: 'Notifications',
  icon: NotificationIcon,
  description: NOTIFICATIONS_SETTINGS_PAGE_DESCRIPTION,
};

export const MESSAGING_PAGE = {
  path: '/settings/messaging',
  label: 'Messaging',
  icon: MessagesIcon,
  description: MESSAGING_SETTINGS_PAGE_DESCRIPTION,
};

export const LANDING_PAGE_SETTING_PAGE = {
  path: '/settings/landing',
  label: 'Marketing website',
  icon: PagesIcon,
  pageIcon: PagesIcon,
  description: PUBLIC_WEBSITE_SETTINGS_PAGE_DESCRIPTION,
};

export const PAYMENTS_PAGE = {
  path: '/settings/payments',
  label: 'Billing',
  icon: PaymentsIcon,
  description: BILLING_SETTINGS_PAGE_DESCRIPTION,
};

export const PROFILE_PAGE = {
  path: '/settings/me',
  label: 'Account',
  icon: AccountIcon,
  description: ACCOUNT_SETTINGS_PAGE_DESCRIPTION,
};

export const MEMBERS_PAGE = {
  path: '/settings/members',
  label: 'Team',
  icon: TeamIcon,
  description: TEAMS_SETTINGS_PAGE_DESCRIPTION,
};

export const API_SETTINGS_PAGE = {
  path: '/settings/api',
  label: 'API',
  icon: HardwareChipIcon,
  description: API_SETTINGS_PAGE_DESCRIPTION,
};

export const WEBHOOK_SETUP_PAGE = {
  path: '/settings/api/webhooks',
  label: 'Create webhook',
  description: `Manage your webhook url and events`,
};

export const APPS_PAGE = {
  path: '/settings/apps',
  label: 'Integrations',
  icon: AppsIcon,
  description: APP_SETTINGS_PAGE_DESCRIPTION,
};

export const MAIN_SETTING_PAGE = {
  path: '/settings/main',
  label: 'General',
  icon: PuzzleIcon,
  description: GENERAL_SETTINGS_PAGE_DESCRIPTION,
};

export const DOMAIN_PAGE = {
  path: '/settings/domain',
  label: 'Domains',
  icon: LinkIcon,
  pageIcon: LinkIcon,
  description: DOMAINS_SETTINGS_PAGE_DESCRIPTION,
};

export const SIGNATURE_PAGE = {
  path: '/signature',
  label: 'Signature',
};

export const SIGNATURE_PAGE_V2 = {
  path: '/signature-v2',
  label: 'Signature',
};

export const PLAN_PAGE = {
  path: '/settings/plan',
  label: 'Plans',
  icon: PlanIcon,
  pageIcon: PlanIcon,
  description: '',
};

export const EXTENSION_ITEM = {
  label: 'Partner & Custom Apps',
  icon: PartnerAppsIcon,
};

export const CLIENT_EXPERIENCE_ITEM = {
  label: 'Client Experience',
  icon: StatusIcon,
  pageIcon: StatusIcon,
};

export const PORTAL_ITEM = {
  label: 'Customization',
  icon: PortalModulesIcon,
  pageIcon: PortalModulesIcon,
};

export const PLAN_PAGE_CANCEL_START = {
  path: '/settings/plan/cancel',
  label: 'Are you sure you want to cancel your plan?',
  description: '',
};

export const PLAN_PAGE_CANCEL_CONFIRM = {
  path: '/settings/plan/cancel/confirm',
  label: 'Would you like to pause your subscription instead?',
  description: '',
};

export const PLAN_PAGE_CANCEL_CONFIRM_CALLOUT =
  'You can pause your Portal account for up to 3 months. During this period, you will not be charged, and you and your clients still have full access to your portal. Note that you can only pause your subscription once every 2 years.';

export const REFERRAL_PAGE = {
  path: '/settings/referral',
  label: 'Refer Copilot',
  icon: GiftIcon,
  pageIcon: GiftIcon,
  description: `Referral gets $${DEFAULT_REFERRAL_AMOUNT} in Portal credit and you earn a $100 Amazon gift card`,
};

export const REFERRAL_PAGE_V2 = {
  path: '/referrals',
  label: 'Referrals',
  icon: GiftIcon,
  pageIcon: GiftIcon,
  description: 'Refer a friend or colleague and receive Amazon gift cards',
};

export const ADD_MODULE_PAGE = {
  path: '/module-management/new',
  label: 'Add an App',
  description: `Choose a module, configure, and connect it to your portal.`,
  icon: CustomizationIcon,
};

export const SettingsPagePathToSettingsMetaDataMap = {
  '/settings': MAIN_SETTING_PAGE,
  [CUSTOMIZATION_PAGE.path]: CUSTOMIZATION_PAGE,
  [BILLING_PAGE.path]: BILLING_PAGE,
  [MODULE_MANAGEMENT_PAGE.path]: MODULE_MANAGEMENT_PAGE,
  [FILES_SETTINGS_PAGE.path]: FILES_SETTINGS_PAGE,
  [MESSAGING_PAGE.path]: MESSAGING_PAGE,
  [LANDING_PAGE_SETTING_PAGE.path]: LANDING_PAGE_SETTING_PAGE,
  [PAYMENTS_PAGE.path]: PAYMENTS_PAGE,
  [PROFILE_PAGE.path]: PROFILE_PAGE,
  [MEMBERS_PAGE.path]: MEMBERS_PAGE,
  [APPS_PAGE.path]: APPS_PAGE,
  [API_SETTINGS_PAGE.path]: API_SETTINGS_PAGE,
  [WEBHOOK_SETUP_PAGE.path]: WEBHOOK_SETUP_PAGE,
  [MAIN_SETTING_PAGE.path]: MAIN_SETTING_PAGE,
  [DOMAIN_PAGE.path]: DOMAIN_PAGE,
  [PLAN_PAGE.path]: PLAN_PAGE,
  [REFERRAL_PAGE.path]: REFERRAL_PAGE,
  [NOTIFICATIONS_SETTINGS_PAGE.path]: NOTIFICATIONS_SETTINGS_PAGE,
  [ADD_MODULE_PAGE.path]: ADD_MODULE_PAGE,
  [PLAN_PAGE_CANCEL_START.path]: PLAN_PAGE_CANCEL_START,
  [PLAN_PAGE_CANCEL_CONFIRM.path]: PLAN_PAGE_CANCEL_CONFIRM,
};

export const ONLY_DESKTOP_SUPPORT_PAGES: Set<string> = new Set<string>([
  CUSTOMIZATION_PAGE.path,
  LANDING_PAGE.path,
]);

export const PORTAL_URL = 'https://copilot.com';

export const SERVICES_PAGE = {
  label: 'Services',
  url: '?page=about_us',
  pageEntityType: PublicSitePages.About,
};

export const TEAM_PAGE = {
  label: 'Team',
  url: '?page=team',
  pageEntityType: PublicSitePages.Team,
};
export const CONTACT_PAGE = {
  label: 'Contact',
  url: '?page=contact_us',
  pageEntityType: PublicSitePages.Contact,
};
export const PRICING_PAGE = {
  label: 'Pricing',
  url: '?page=pricing',
  pageEntityType: PublicSitePages.Pricing,
};

export const LANDING_HOME_PAGE_TITLE = 'Home';
export const LANDING_PAGE_LINKS = [
  SERVICES_PAGE,
  TEAM_PAGE,
  CONTACT_PAGE,
  PRICING_PAGE,
];

export const FORMS_PAGE = {
  path: '/forms',
  label: 'Forms',
  icon: FormsIcon,
};

export const FORMS_PAGE_V2 = {
  path: '/forms-v2',
  label: 'Forms',
  icon: FormsIcon,
};

export const FORMS_DETAIL_PAGE_V2 = {
  path: '/forms/details',
};

export const FORMS_RESPONSE_PAGE = {
  path: '/forms/response',
};

export const TOS_LINK = 'https://copilot.com/legal/terms-of-service';
export const PRIVACY_POLICY_LINK = 'https://copilot.com/legal/privacy-policy';

export const DEFAULT_SETTINGS_PAGE = 'me';

// these are all the page paths that can lead to different pages based on their
// query param. E.g. the extension path can have multiple items in the sidebar
// that are distinguished by their query param.
export const PagePathsRoutedWithQuery = [EXTENSION_EMBED_PAGE.path];

// Starting route of path that an IU sees when they want to
// go to a specific portal. E.g. `/portal/portalId`
export const PORTAL_PATH = '/portal';
